export default __webpack_public_path__ + "static/media/noun_plus button.02853cdc.png";